// src/components/editor/FilePanel.jsx
//
// Publish used to live here as well. It now sits in the editor's doc bar, so
// there is a single publish entry point rather than two buttons opening the
// same modal; this panel keeps the file-level actions around it.
import React from 'react';
import { Box, Button } from '@mui/material';
import SaveStatusIndicator from '../common/SaveStatusIndicator';

const btnStyle = {
  width: '100%',
  background: '#D4AF37',
  color: '#1A1A1A',
  fontWeight: 600,
  fontSize: '0.875rem',
  textTransform: 'uppercase',
  borderRadius: '8px',
  padding: '12px 24px',
  '&:hover': { background: '#F5D76E' },
};

export default function FilePanel({
  onCreateBookCover,
  onWriteBlurb,
  onOpenStructure,
  onDownloadPdf,
  downloadingPdf = false,
  onSaveProgress,
  onSaveAndClose,
  saveStatus,
}) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
      {saveStatus && (
        <SaveStatusIndicator status={saveStatus} onRetry={onSaveProgress} sx={{ marginBottom: '4px' }} />
      )}
      <Button variant="contained" onClick={onCreateBookCover} sx={btnStyle}>
        Create Book Cover
      </Button>
      <Button variant="contained" onClick={onWriteBlurb} sx={btnStyle}>
        Write Blurb
      </Button>
      {/* Second entry point to /manuscript/:id/structure. The three-dot menu
          on the draft card still opens the same page; this one is for an
          author already inside the editor. Sits with the other "go somewhere
          and make something" actions, above the two Save buttons. */}
      <Button variant="contained" onClick={onOpenStructure} sx={btnStyle}>
        Manuscript Structure
      </Button>
      {/* The server builds the book fresh for a download, which takes a few
          seconds; the label says so, and the button cannot be pressed twice. */}
      <Button variant="contained" onClick={onDownloadPdf} disabled={downloadingPdf} sx={btnStyle}>
        {downloadingPdf ? 'Preparing your PDF…' : 'Download PDF'}
      </Button>
      <Button variant="contained" onClick={onSaveProgress} sx={btnStyle}>
        Save Progress
      </Button>
      <Button variant="contained" onClick={onSaveAndClose} sx={btnStyle}>
        Save &amp; Close
      </Button>
    </Box>
  );
}
